import { render, staticRenderFns } from "./ToggleSidebar.vue?vue&type=template&id=bdf44722&scoped=true"
import script from "./ToggleSidebar.vue?vue&type=script&lang=js"
export * from "./ToggleSidebar.vue?vue&type=script&lang=js"
import style0 from "./ToggleSidebar.vue?vue&type=style&index=0&id=bdf44722&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf44722",
  null
  
)

export default component.exports